;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { MultilinkStoryblok } from '@qogita/cms'
import { cn } from '@qogita/ui/utils/cn'
import { BaseAnchor } from '@qogita/ui/v2/base-anchor'
import { ReactNode } from 'react'

export function CtaOutlined({
  children,
  link,
  className,
}: {
  link: MultilinkStoryblok
  children: ReactNode
  className?: string
}) {
  return (
    <BaseAnchor
      target={link.target}
      href={link.story?.url ?? link.url}
      className={cn(
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        'rounded-sm border border-gray-800 px-6 py-4 text-center tracking-[1px] text-gray-800 hover:bg-gray-50 active:shadow-gray-800',
        className,
      )}
    >
      {children}
    </BaseAnchor>
  )
}

export function CtaContained({
  children,
  link,
  className,
}: {
  link: MultilinkStoryblok
  children: ReactNode
  className?: string
}) {
  return (
    <BaseAnchor
      target={link.target}
      href={link.story?.url ?? link.url}
      className={cn(
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        'rounded-sm border border-gray-800 bg-gray-800 px-6 py-4 text-center tracking-[1px] text-gray-50 hover:bg-gray-700 active:bg-gray-900',
        className,
      )}
    >
      {children}
    </BaseAnchor>
  )
}

export function CtaWhite({
  children,
  link,
  className,
}: {
  link: MultilinkStoryblok
  children: ReactNode
  className?: string
}) {
  return (
    <BaseAnchor
      target={link.target}
      href={link.story?.url ?? link.url}
      className={cn(
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        'rounded-sm bg-white px-6 py-4 text-center tracking-[1px] text-gray-700 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-100 active:text-gray-700 disabled:bg-gray-200 disabled:text-gray-700',
        className,
      )}
    >
      {children}
    </BaseAnchor>
  )
}
